<template>
  <div class="signup-wizard">
    <div
      v-if="showBackButton"
      @click="back()"
      class="back"
      :class="{ 'coupon-applied': couponApplied }"
    >
      <ArrowLeftIcon />
      <span class="back-text">BACK</span>
    </div>
    <div
      class="steps-container"
      :class="{ 'special-background': currentStep === 6 }"
    >
      <SignupWizardStepEmail
        v-if="currentStep === 1 || !currentStep"
        @close="close()"
        @nextStep="nextStep"
      />
      <SignupWizardStepVerifyEmail
        v-if="currentStep === 2"
        @close="close()"
        @nextStep="nextStep"
      />
      <SignupWizardStepPassword
        v-if="currentStep === 3"
        @close="close()"
        @nextStep="nextStep"
      />
      <SignupWizardStepSetName
        v-if="currentStep === 4"
        @close="close()"
        @nextStep="nextStep"
      />
      <SignupWizardStepAddArtist
        v-if="currentStep === 5"
        @close="close()"
        @nextStep="nextStep"
      />
      <SignupWizardStepSelectPlan
        v-if="currentStep === 6"
        @close="close()"
        @nextStep="nextStep"
        @setStep="setStep"
        @submit="submit"
      />
      <!-- <SignupWizardStepBilling
        v-if="currentStep === 7"
        @close="close()"
        @nextStep="nextStep"
      /> -->
      <SignupWizardStepFinished
        v-if="currentStep === 7"
        @close="close()"
        @nextStep="nextStep"
        @finish="onFinish()"
      />
    </div>
    <SnackBar>
      <template v-slot:icon></template>
    </SnackBar>
  </div>
</template>
<script>
import ArrowLeftIcon from "../../../public/img/icons/arrow-left.svg";
import SignupWizardStepEmail from "@/components/Custom/SignupWizardStepEmail";
import SignupWizardStepVerifyEmail from "@/components/Custom/SignupWizardStepVerifyEmail";
import SignupWizardStepPassword from "@/components/Custom/SignupWizardStepPassword";
import SignupWizardStepSetName from "@/components/Custom/SignupWizardStepSetName";
import SignupWizardStepAddArtist from "@/components/Custom/SignupWizardStepAddArtist";
import SignupWizardStepSelectPlan from "@/components/Custom/SignupWizardStepSelectPlan";
// import SignupWizardStepBilling from "@/components/Custom/SignupWizardStepBilling";
import SignupWizardStepFinished from "@/components/Custom/SignupWizardStepFinished";
import SnackBar from "@/components/Custom/SnackBar";
import { mapState } from "vuex";
export default {
  name: "SignupWizard",
  components: {
    ArrowLeftIcon,
    SignupWizardStepEmail,
    SignupWizardStepVerifyEmail,
    SignupWizardStepPassword,
    SignupWizardStepSetName,
    SignupWizardStepAddArtist,
    SignupWizardStepSelectPlan,
    // SignupWizardStepBilling,
    SignupWizardStepFinished,
    SnackBar,
  },
  data() {
    return {
      hash: null,
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.trial) {
      this.hash = "#pricing";
      this.$router.replace({ query: {} });
    }
  },
  computed: {
    ...mapState("signup", [
      "currentStep",
      "email",
      "artists",
      "selected_plan",
      "id",
      "email_pending",
    ]),
    showBackButton() {
      // return [7, 8].includes(this.currentStep);
      return false;
    },
    couponApplied() {
      return !!this.$cookies.get("coupon");
    },
    user() {
      return this.$store.getters.getUser;
    },
  },
  watch: {
    currentStep(from, to) {
      console.log("currentStep", from, to);
    },
    email(val) {
      if (!val && this.currentStep > 1) {
        this.$store.commit("signup/reset");
        this.$store.commit("logout");
        this.setStep(1);
      }
    },
    id(val) {
      if (!val && this.currentStep > 2) {
        this.$store.commit("signup/reset");
        this.$store.commit("logout");
        this.setStep(1);
      }
    },
  },
  created() {
    if (this.currentStep === 1 && this.email) {
      this.setStep(this.email_pending ? 2 : 3);
    }
    if (
      this.currentStep > 5 &&
      (!this.user.artists.length ||
        this.user.artists.every((artist) => !artist.artist_name))
    ) {
      this.setStep(5);
    }
    if (this.currentStep > 6 && !this.selected_plan) {
      this.setStep(6);
    }
  },
  methods: {
    setStep(step) {
      // this.currentStep = step;
      this.$store.commit("signup/setStep", step);
    },
    async nextStep() {
      this.$store.commit("signup/nextStep");
    },
    async onFinish() {
      console.log("finished");
      document.location = "/links";
    },
    back() {
      this.$store.commit("signup/previousStep");
    },
    close() {
      this.$emit("close");
    },
    logout() {
      if (this.currentStep === 1) {
        const page = { name: "Homepage" };
        if (this.hash) page.hash = this.hash;
        this.$router.push(page);
      } else {
        document.location = "/logout";
      }
    },
    submit() {
      console.log("submit");
    },
  },
};
</script>
<style lang="scss" scoped>
.special-background {
  background: $bg-type-4;
}
.signup-wizard {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  /* BG/type1 */
  background: $bg-type-2;
  .steps-container {
    flex: 1;
    display: flex;
    justify-content: center;
    overflow-y: auto;
    padding: 60px 0;
  }
  .back {
    cursor: pointer;
    position: fixed;
    top: 66px;
    left: 66px;
    display: flex;
    //flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    &:hover {
      svg {
        path {
          fill: white;
        }
      }
      .back-text {
        color: white;
      }
    }
    svg {
      width: 28px;
      margin: 3px 0;
      path {
        fill: #8786ab;
      }
    }
    .back-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;
      text-transform: uppercase;
      /* Text/type2 */
      color: $text-type-2;
    }
    &.coupon-applied {
      top: 86px;
    }
  }
  .close {
    cursor: pointer;
    position: fixed;
    top: 44px;
    right: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:hover {
      svg {
        path {
          fill: white;
        }
      }
      .close-text {
        color: white;
      }
    }
    svg {
      width: 18px;
      margin: 3px 0;
      path {
        fill: #8786ab;
      }
    }
    .close-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 10px;
      text-transform: uppercase;
      /* Text/type2 */
      color: $text-type-2;
    }
    &.coupon-applied {
      top: 86px;
    }
  }
}
@media (max-width: 600px) {
  .signup-wizard {
    .back {
      top: 24px;
      left: 24px;
      position: absolute;
    }
    .steps-container {
      display: block;
      overflow-y: initial;
    }
  }
}
</style>
